/**
 * Small, non-intrusive promo strip nudging players to stock erasers.
 *
 * Used in place of the install-card on /home and as a top strip on /wallet.
 * Compact single-row layout (matches the install_card silhouette so a swap
 * doesn't shift the page) and links straight to /erasers.
 */

export function buyEraserBannerHtml() {
  return `
    <div
      class="card buy-eraser-banner"
      style="padding:8px 10px;margin-bottom:8px;background:linear-gradient(135deg,#3a2a14 0%,#5B2C91 100%);border-color:rgba(229,193,0,0.45);"
    >
      <a href="/shop" data-link class="row"
         style="align-items:center;gap:8px;text-decoration:none;color:inherit;min-width:0;">
        <div style="font-size:18px;line-height:1;color:var(--gold-t);flex-shrink:0;">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none"
               stroke="currentColor" stroke-width="2.2"
               stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"
               style="display:block;">
            <path d="m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21"/>
            <path d="M22 21H7"/>
            <path d="m5 11 9 9"/>
          </svg>
        </div>
        <div class="grow" style="min-width:0;">
          <div style="color:#fff;font-weight:700;font-size:12.5px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
            Erasers turn a wrong answer into a right one
          </div>
          <div style="color:rgba(255,255,255,0.72);font-weight:500;font-size:10.5px;line-height:1.25;margin-top:1px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
            Bring some to your next live trivia
          </div>
        </div>
        <span
          class="btn sm gold"
          style="padding:4px 10px;font-size:12px;line-height:1.2;flex-shrink:0;margin:0;"
        >
          Buy
        </span>
      </a>
    </div>
  `;
}
